import { render, staticRenderFns } from "./BulkResultTabs.vue?vue&type=template&id=52a71a6e"
import script from "./BulkResultTabs.vue?vue&type=script&lang=js"
export * from "./BulkResultTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports